module.exports = __webpack_public_path__ + "static/media/johanna.028343b8.JPG";